// extracted by css-extract-rspack-plugin
export default {"row":"gfMRU","nowrap":"SVz4d"};